import { createAction } from "@reduxjs/toolkit";
import type { AdminUpdateInternalTrainingBody } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminUpdateInternalTraining = createApiThunk<void, AdminUpdateInternalTrainingBody>(
  "internalTrainings/updateInternalTraining",
  async (body: AdminUpdateInternalTrainingBody, { extra: { adminRepository } }) => {
    return adminRepository!.updateInternalTraining(body);
  },
);

export const adminResetUpdateInternalTraining = createAction("internalTrainings/resetUpdateInternalTraining");
